module.exports = __webpack_public_path__ + "static/media/sad.244f36d4.png";